module.exports = {
    CHAM_CAROUSEL_OBSERVER_B: 2611,
    LIONS_GIG_CARD_FORMATTING: 3110,
    GIG_PAGE_V5_EXPERIMENT: 3119,
    LIONS_FORMATTING_QA: 3140,
    CHAM_GROWTH_CAROUSEL_EXTERNAL_VISITS: 3157,
    OWLS_CHOICE_PRICE_MODALITIES_AUTOMATION_EXP: 3164,
    LIONS_FORMATTING_ALL_LOCALES_ALL_CURRENCIES: 3217,
    PORTFOLIO_PRESENCE_ABTEST: 3232,
    FOXES_CREATE_BRIEF: 3253,
    QUAL_REVIEWS_WORK_SAMPLE_MOBILE: 3255,
    QUALAS_GIG_RATING_PROJECT_1: 3273,
    LIONS_PROMOTE_LOCAL_SITES: 3300,
    QUALAS_REVIEWS_SBSS_INDICATION: 3309,
    GIG_PAGE_LAYOUT_EXPERIMENT: 3311,
    GOATS_GIG_PAGE_STICKY_CTA: 3317
};
